import './Loading.css';
import logoCompleto from '../assets/Niva - Montañas-horizontal.png';

export default function Loading() {
  return (
    <div className="loading-wrapper">
      {/* Background Decorations */}
      <div className="loading-bg-decorations" aria-hidden="true">
        <div className="loading-blob loading-blob--1"></div>
        <div className="loading-blob loading-blob--2"></div>
        <div className="loading-blob loading-blob--3"></div>
      </div>

      <div className="loading-content">
        {/* Logo with animation */}
        <div className="loading-logo-container">
          <img 
            src={logoCompleto} 
            alt="Niva" 
            className="loading-logo"
          />
        </div>

        

        {/* Animated dots */}
        <div className="loading-dots">
          <span className="loading-dot"></span>
          <span className="loading-dot"></span>
          <span className="loading-dot"></span>
        </div>

        {/* Progress bar */}
        <div className="loading-progress-container">
          <div className="loading-progress-bar"></div>
        </div>
      </div>
    </div>
  );
}
